'use client'

import { Box, BoxProps as MuiBoxProps } from '@mui/joy'
import color from '@ui/style/color.theme'
import { pxToRem } from '@ui/style/muiTheme'
import zIndexes from '@ui/style/zIndexes.theme'
import useScrollProgress from '../hooks/useScrollProgress'
import { useCallback, useEffect, useState } from 'react'
import { useScrapReadMutation } from '@services/api/Article/ScrapRead/mutation'
import { useAuthControl } from '@store/auth'
import { useHeaderStates } from '@components/layout/Header/store/store'

export interface ScrollProgressProps extends MuiBoxProps {
	articleIdx?: string
	targetAreaRef: React.RefObject<HTMLElement> | null
	isScrollDown: boolean
}

const ScrollProgressBar = ({
	articleIdx,
	targetAreaRef,
	isScrollDown,
	...props
}: ScrollProgressProps) => {
	const [read, setRead] = useState<boolean>(false)
	const progress = useScrollProgress(targetAreaRef)
	const { auth } = useAuthControl()
	const [headerStates] = useHeaderStates()
	const { mutateAsync: mutateRead } = useScrapReadMutation()

	const updateRead = useCallback(async () => {
		if (auth && articleIdx && !read && progress > 50) {
			setRead(true)
			mutateRead({ articleIdx })
		}
	}, [auth, progress, articleIdx, read])
	useEffect(() => {
		updateRead()
	}, [updateRead])
	return (
		<Box
			zIndex={zIndexes.header - 1}
			width="100%"
			position="fixed"
			left="0"
			top={{ xs: pxToRem(52), md: pxToRem(84) }}
			sx={{
				display: {
					xs: headerStates.megaMenuOpen || headerStates.alarmOpen ? 'none' : 'block',
					md: headerStates.megaMenuOpen ? 'none' : 'block',
				},
				background: color.colGray3,
				opacity: 0,
				height: pxToRem(4),
				visibility: 'hidden',
				'&.is-pinned': {
					opacity: 1,
					visibility: 'visible',
				},
			}}
			{...props}
		>
			<Box
				width={`${progress}%`}
				height="100%"
				sx={{ background: color.colMintBlue, transition: 'all 0.2s' }}
			/>
		</Box>
	)
}

export default ScrollProgressBar
